import React from 'react'

const MediaCommentsIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M8.00261 1.3327C4.32061 1.3327 1.33594 4.31736 1.33594 7.99936C1.33537 8.98162 1.55187 9.95186 1.96994 10.8407L1.34994 13.8654C1.32786 13.9734 1.33291 14.0851 1.36463 14.1907C1.39635 14.2963 1.45375 14.3923 1.5317 14.4703C1.60964 14.5482 1.70569 14.6056 1.81126 14.6373C1.91683 14.6691 2.02861 14.6741 2.13661 14.652L5.16127 14.032C6.02394 14.4387 6.98794 14.6654 8.00261 14.6654C11.6846 14.6654 14.6693 11.6814 14.6693 7.9987C14.6693 4.31736 11.6846 1.33203 8.00261 1.33203" fill="white" />
        </svg>
    )
}

export default MediaCommentsIcon
